export interface IServerStatus {
  running: boolean;
  port: number;
  clientCount: number;
  socketEnabled: boolean;
  connectedClients: number;
  ipv4: string[];
  ipv6: string[];
}

export const createDefServerStatus = (): IServerStatus => ({
  running: false,
  port: 6001,
  clientCount: 0,
  socketEnabled: false,
  connectedClients: 0,
  ipv4: [],
  ipv6: [],
});